/**
 * Lynden Liquid Finder — quiz + catalog scoring (DEV)
 * Steps: system → nicotine → flavor → budget → pref
 */
(function () {
  var TOTAL_STEPS = 5;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function money(cents) {
    var n = (Number(cents) / 100).toFixed(2).replace(".", ",");
    return n + " €";
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function parseQuery() {
    var out = {};
    var s = window.location.search.replace(/^\?/, "");
    if (!s) return out;
    s.split("&").forEach(function (pair) {
      var p = pair.split("=");
      if (!p[0]) return;
      out[decodeURIComponent(p[0])] = decodeURIComponent((p[1] || "").replace(/\+/g, " "));
    });
    return out;
  }

  var LABELS = {
    system: {
      mtl: "Pod / MTL",
      dtl: "DTL / Subohm",
      unknown: "System egal",
    },
    nicotine: {
      "0": "Ohne Nikotin",
      light: "Leicht",
      medium: "Mittel",
      strong: "Stark",
      any: "Stärke egal",
    },
    flavor: {
      frucht: "Frucht",
      menthol: "Menthol / Ice",
      tabak: "Tabak",
      suess: "Süß / Dessert",
      getraenk: "Getränk",
      surprise: "Überrasch mich",
    },
    budget: {
      entry: "bis ca. 8 €",
      mid: "ca. 8–12 €",
      premium: "Premium ok",
      any: "Preis egal",
    },
    pref: {
      fresh: "Frisch & kühl",
      sweet: "Süß & weich",
      bold: "Kräftig & klar",
      none: "Keine Präferenz",
    },
  };

  /** Budget bands in cents (catalog uses minor units). */
  var BUDGET = {
    entry: { min: 0, max: 800 },
    mid: { min: 801, max: 1200 },
    premium: { min: 1201, max: Infinity },
    any: { min: 0, max: Infinity },
  };

  function strengthMatch(strengths, nic) {
    if (!strengths || !strengths.length) return nic === "any" ? 0.5 : 0.2;
    if (nic === "any") return 1;
    if (nic === "0") {
      return strengths.some(function (s) {
        return s === 0;
      })
        ? 1
        : 0;
    }
    var ranges = {
      light: [1, 7],
      medium: [8, 14],
      strong: [15, 25],
    };
    var r = ranges[nic];
    if (!r) return 0.3;
    var hit = strengths.some(function (s) {
      return s >= r[0] && s <= r[1];
    });
    return hit ? 1 : 0.05;
  }

  function priceInBand(price, budget, softPad) {
    softPad = softPad || 0;
    var band = BUDGET[budget] || BUDGET.any;
    var min = Math.max(0, band.min - (budget === "mid" ? softPad : 0));
    var max = band.max === Infinity ? Infinity : band.max + softPad;
    if (budget === "premium") {
      // Premium: open upward; soft pad allows slightly under 12€
      min = Math.max(0, band.min - softPad);
      max = Infinity;
    }
    if (budget === "entry") {
      min = 0;
      max = band.max + softPad;
    }
    if (budget === "any") return true;
    return price >= min && price <= max;
  }

  function scoreProduct(p, state, softPad) {
    var score = 0;
    var why = [];
    softPad = softPad || 0;

    // availability boost
    if (p.available) score += 2;
    else score -= 3;

    // system / salt
    var sys = state.system || "unknown";
    if (sys === "mtl" || sys === "unknown") {
      if (p.salt) {
        score += 4;
        why.push("Nikotinsalz für Pods/MTL");
      } else {
        score += 0.5;
      }
    } else if (sys === "dtl") {
      if (!p.salt) {
        score += 4;
        why.push("klassisches Liquid / Freebase-Richtung");
      } else {
        score += 0.3;
      }
    }

    // nicotine
    var sm = strengthMatch(p.strengths, state.nicotine || "any");
    score += sm * 5;
    if (sm >= 1 && state.nicotine && state.nicotine !== "any") {
      why.push(LABELS.nicotine[state.nicotine] || "passende Stärke");
    }

    // flavors (multi)
    var flavors = state.flavors || [];
    var surprise = flavors.indexOf("surprise") !== -1 || flavors.length === 0;
    if (surprise) {
      score += 1.5;
    } else {
      var fam = p.families || [];
      var hits = flavors.filter(function (f) {
        return fam.indexOf(f) !== -1;
      });
      if (hits.length) {
        score += 5 + hits.length;
        hits.slice(0, 2).forEach(function (h) {
          why.push(LABELS.flavor[h] || h);
        });
      } else {
        score -= 1.5;
      }
    }

    // budget
    var budget = state.budget || "any";
    var price = Number(p.price) || 0;
    if (budget !== "any") {
      if (priceInBand(price, budget, 0)) {
        score += 4;
        why.push(LABELS.budget[budget]);
        // within band: prefer better value for entry/mid
        if (budget === "entry") score += Math.max(0, (800 - price) / 800);
        if (budget === "mid") score += 0.3;
      } else if (softPad > 0 && priceInBand(price, budget, softPad)) {
        score += 1.2; // soft expansion
        why.push("nah am Budget");
      } else {
        score -= 6; // hard miss when not expanded
      }
    }

    // preference
    var pref = state.pref || "none";
    var fams = p.families || [];
    if (pref === "fresh" && fams.indexOf("menthol") !== -1) {
      score += 2;
      why.push("frisch/kühl");
    } else if (pref === "sweet" && (fams.indexOf("suess") !== -1 || fams.indexOf("frucht") !== -1)) {
      score += 1.5;
    } else if (pref === "bold" && (fams.indexOf("tabak") !== -1 || fams.indexOf("getraenk") !== -1)) {
      score += 1.2;
    }

    // slight diversity: popular vendors lightly boosted if available
    var hot = ["ELFLIQ", "ELUX", "FLERBAR", "BAD CANDY", "DR. FROST", "Happy Liquid", "InnoCigs"];
    if (hot.indexOf(p.vendor) !== -1 && p.available) score += 0.4;

    return { score: score, why: why };
  }

  function formatStrengths(strengths) {
    if (!strengths || !strengths.length) return "";
    var s = strengths
      .slice()
      .sort(function (a, b) {
        return a - b;
      })
      .map(function (n) {
        return (n % 1 === 0 ? String(n) : String(n).replace(".", ",")) + " mg";
      });
    if (s.length <= 3) return s.join(" · ");
    return s[0] + "–" + s[s.length - 1];
  }

  function init(root) {
    if (!root || root.dataset.lfReady === "1") return;
    root.dataset.lfReady = "1";

    var catalogUrl = root.getAttribute("data-catalog-url");
    var maxResults = parseInt(root.getAttribute("data-results-count") || "6", 10) || 6;
    var state = {
      system: null,
      nicotine: null,
      flavors: [],
      budget: null,
      pref: null,
    };
    var step = 0;
    var catalog = null;
    var catalogPromise = null;

    var steps = qsa("[data-lf-step]", root);
    var results = qs("[data-lf-results]", root);
    var grid = qs("[data-lf-grid]", root);
    var emptyEl = qs("[data-lf-empty]", root);
    var backBtn = qs("[data-lf-back]", root);
    var nextBtn = qs("[data-lf-next]", root);
    var stepMeta = qs("[data-lf-step-meta]", root);
    var dots = qsa("[data-lf-dot]", root);
    var summaryEl = qs("[data-lf-summary]", root);
    var chipsEl = qs("[data-lf-summary-chips]", root);
    var browseLink = qs("[data-lf-browse]", root);

    function loadCatalog() {
      if (catalog) return Promise.resolve(catalog);
      if (catalogPromise) return catalogPromise;
      catalogPromise = fetch(catalogUrl, { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error("catalog " + r.status);
          return r.json();
        })
        .then(function (data) {
          catalog = data;
          return data;
        })
        .catch(function (err) {
          catalogPromise = null;
          console.warn("[liquid-finder] catalog failed", err);
          return { products: [] };
        });
      return catalogPromise;
    }

    loadCatalog();

    function canProceed() {
      if (step === 0) return !!state.system;
      if (step === 1) return !!state.nicotine;
      if (step === 2) return state.flavors.length > 0;
      if (step === 3) return !!state.budget;
      if (step === 4) return !!state.pref;
      return false;
    }

    function updateNav() {
      if (backBtn) backBtn.hidden = step === 0;
      if (nextBtn) {
        nextBtn.disabled = !canProceed();
        nextBtn.textContent = step >= TOTAL_STEPS - 1 ? "Vorschläge zeigen" : "Weiter";
      }
      if (stepMeta) stepMeta.textContent = "Schritt " + (step + 1) + " von " + TOTAL_STEPS;
      dots.forEach(function (d, i) {
        d.classList.toggle("is-active", i === step);
        d.classList.toggle("is-done", i < step);
      });
    }

    function showStep(n) {
      step = n;
      steps.forEach(function (sec) {
        var i = parseInt(sec.getAttribute("data-lf-step"), 10);
        var on = i === step;
        sec.hidden = !on;
        sec.classList.toggle("is-active", on);
      });
      if (results) results.hidden = true;
      var nav = qs(".lyd-lf__nav", root);
      if (nav) nav.hidden = false;
      if (stepMeta) stepMeta.hidden = false;
      var prog = qs("[data-lf-progress]", root);
      if (prog) prog.hidden = false;
      updateNav();
      try {
        window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.scrollY - 16), behavior: "smooth" });
      } catch (e) {}
    }

    function selectSingle(choice, value, btn) {
      qsa('[data-lf-choice="' + choice + '"]', root).forEach(function (b) {
        b.classList.remove("is-selected");
      });
      btn.classList.add("is-selected");
      if (choice === "system") state.system = value;
      if (choice === "nicotine") state.nicotine = value;
      if (choice === "budget") state.budget = value;
      if (choice === "pref") state.pref = value;
      updateNav();
    }

    function toggleFlavor(value, btn) {
      if (value === "surprise") {
        state.flavors = ["surprise"];
        qsa('[data-lf-choice="flavor"]', root).forEach(function (b) {
          b.classList.toggle("is-selected", b.getAttribute("data-value") === "surprise");
        });
      } else {
        state.flavors = state.flavors.filter(function (f) {
          return f !== "surprise";
        });
        var idx = state.flavors.indexOf(value);
        if (idx === -1) state.flavors.push(value);
        else state.flavors.splice(idx, 1);
        qsa('[data-lf-choice="flavor"]', root).forEach(function (b) {
          var v = b.getAttribute("data-value");
          if (v === "surprise") b.classList.remove("is-selected");
          else b.classList.toggle("is-selected", state.flavors.indexOf(v) !== -1);
        });
      }
      updateNav();
    }

    root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-lf-choice]");
      if (btn && root.contains(btn)) {
        var choice = btn.getAttribute("data-lf-choice");
        var value = btn.getAttribute("data-value");
        if (choice === "flavor") toggleFlavor(value, btn);
        else selectSingle(choice, value, btn);
        return;
      }
      if (e.target.closest("[data-lf-next]")) {
        if (!canProceed()) return;
        if (step < TOTAL_STEPS - 1) showStep(step + 1);
        else showResults();
        return;
      }
      if (e.target.closest("[data-lf-back]")) {
        if (step > 0) showStep(step - 1);
        return;
      }
      if (e.target.closest("[data-lf-restart]")) {
        state = { system: null, nicotine: null, flavors: [], budget: null, pref: null };
        qsa(".lyd-lf__opt", root).forEach(function (b) {
          b.classList.remove("is-selected");
        });
        showStep(0);
      }
    });

    function buildSummary() {
      var parts = [];
      if (state.system) parts.push(LABELS.system[state.system]);
      if (state.nicotine) parts.push(LABELS.nicotine[state.nicotine]);
      if (state.flavors && state.flavors.length) {
        parts.push(
          state.flavors
            .map(function (f) {
              return LABELS.flavor[f] || f;
            })
            .join(", ")
        );
      }
      if (state.budget) parts.push(LABELS.budget[state.budget]);
      if (state.pref && state.pref !== "none") parts.push(LABELS.pref[state.pref]);
      return parts;
    }

    function rankProducts(products, softPad) {
      return products
        .map(function (p) {
          var r = scoreProduct(p, state, softPad);
          return { p: p, score: r.score, why: r.why };
        })
        .filter(function (x) {
          return x.score > 0;
        })
        .sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          // tie-break: lower price for entry/mid budgets
          if (state.budget === "entry" || state.budget === "mid") {
            return (a.p.price || 0) - (b.p.price || 0);
          }
          return 0;
        });
    }

    function pickDiversified(ranked) {
      var picked = [];
      var vendorCount = {};
      for (var i = 0; i < ranked.length && picked.length < maxResults; i++) {
        var item = ranked[i];
        var v = item.p.vendor || "_";
        vendorCount[v] = vendorCount[v] || 0;
        if (vendorCount[v] >= 2) continue;
        vendorCount[v]++;
        picked.push(item);
      }
      if (picked.length < maxResults) {
        ranked.forEach(function (item) {
          if (picked.length >= maxResults) return;
          if (picked.indexOf(item) !== -1) return;
          picked.push(item);
        });
      }
      return picked;
    }

    function showResults() {
      steps.forEach(function (sec) {
        sec.hidden = true;
        sec.classList.remove("is-active");
      });
      var nav = qs(".lyd-lf__nav", root);
      if (nav) nav.hidden = true;
      if (stepMeta) stepMeta.hidden = true;
      var prog = qs("[data-lf-progress]", root);
      if (prog) prog.hidden = true;

      results.hidden = false;
      root.classList.add("is-loading");
      grid.innerHTML = "";
      emptyEl.hidden = true;

      var chips = buildSummary();
      if (summaryEl) {
        summaryEl.textContent =
          chips.length > 0
            ? "Basierend auf deiner Auswahl — sortiert nach Passung und Budget. Tippe ein Produkt für Details & Stärken."
            : "Vorschläge aus dem Sortiment.";
      }
      if (chipsEl) {
        chipsEl.innerHTML = chips
          .map(function (c) {
            return '<span class="lyd-lf__chip">' + escapeHtml(c) + "</span>";
          })
          .join("");
      }

      if (browseLink) {
        if (state.system === "dtl") browseLink.href = "/collections/liquids";
        else browseLink.href = "/collections/nikotinsalz-liquids";
      }

      try {
        var params = new URLSearchParams();
        if (state.system) params.set("system", state.system);
        if (state.nicotine) params.set("nicotine", state.nicotine);
        if (state.flavors.length) params.set("flavor", state.flavors.join(","));
        if (state.budget) params.set("budget", state.budget);
        if (state.pref) params.set("pref", state.pref);
        params.set("go", "1");
        // keep preview_theme_id if present
        var existing = parseQuery();
        if (existing.preview_theme_id) params.set("preview_theme_id", existing.preview_theme_id);
        var url = window.location.pathname + "?" + params.toString() + window.location.hash;
        history.replaceState(null, "", url);
      } catch (e) {}

      loadCatalog().then(function (data) {
        root.classList.remove("is-loading");
        var products = (data && data.products) || [];

        // Strict budget first; soft-expand if too few hits
        var ranked = rankProducts(products, 0);
        var picked = pickDiversified(ranked);
        var expanded = false;
        if (picked.length < 3 && state.budget && state.budget !== "any") {
          ranked = rankProducts(products, 250); // +2,50 € soft pad
          picked = pickDiversified(ranked);
          expanded = true;
        }

        if (!picked.length) {
          emptyEl.hidden = false;
          return;
        }

        if (expanded && summaryEl) {
          summaryEl.textContent =
            "Wenige exakte Budget-Treffer — wir haben die Preisspanne etwas erweitert. Sortiert nach Passung.";
        }

        grid.innerHTML = picked
          .map(function (item) {
            var p = item.p;
            var why =
              item.why && item.why.length
                ? item.why.slice(0, 2).join(" · ")
                : p.salt
                  ? "Nikotinsalz-Liquid"
                  : "E-Liquid";
            var str = formatStrengths(p.strengths);
            var typePill = p.salt ? "Nikotinsalz" : "Liquid";
            var img = p.image
              ? '<img src="' +
                escapeAttr(p.image) +
                '" alt="" width="240" height="240" loading="lazy">'
              : "";
            return (
              '<a class="lyd-lf__card" href="' +
              escapeAttr(p.url) +
              '">' +
              '<div class="lyd-lf__card-img">' +
              img +
              "</div>" +
              '<div class="lyd-lf__card-body">' +
              (p.vendor
                ? '<span class="lyd-lf__card-vendor">' + escapeHtml(p.vendor) + "</span>"
                : "") +
              "<h3>" +
              escapeHtml(p.title) +
              "</h3>" +
              '<p class="lyd-lf__card-why">' +
              escapeHtml(why) +
              "</p>" +
              '<div class="lyd-lf__card-meta">' +
              '<span class="lyd-lf__pill">' +
              escapeHtml(typePill) +
              "</span>" +
              (str ? '<span class="lyd-lf__pill">' + escapeHtml(str) + "</span>" : "") +
              (!p.available ? '<span class="lyd-lf__pill">Aktuell rar</span>' : "") +
              "</div>" +
              '<div class="lyd-lf__card-price">ab ' +
              money(p.price) +
              " <span>inkl. MwSt.</span></div>" +
              "</div></a>"
            );
          })
          .join("");

        try {
          window.scrollTo({
            top: Math.max(0, results.getBoundingClientRect().top + window.scrollY - 20),
            behavior: "smooth",
          });
        } catch (e2) {}
      });
    }

    function escapeHtml(s) {
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }
    function escapeAttr(s) {
      return escapeHtml(s).replace(/'/g, "&#39;");
    }

    // Prefill from query
    var q = parseQuery();
    if (q.system && LABELS.system[q.system]) {
      state.system = q.system;
      var b = qs('[data-lf-choice="system"][data-value="' + q.system + '"]', root);
      if (b) b.classList.add("is-selected");
    }
    if (q.nicotine && LABELS.nicotine[q.nicotine]) {
      state.nicotine = q.nicotine;
      var b2 = qs('[data-lf-choice="nicotine"][data-value="' + q.nicotine + '"]', root);
      if (b2) b2.classList.add("is-selected");
    }
    if (q.flavor) {
      state.flavors = q.flavor.split(",").filter(function (f) {
        return !!LABELS.flavor[f];
      });
      state.flavors.forEach(function (f) {
        var bf = qs('[data-lf-choice="flavor"][data-value="' + f + '"]', root);
        if (bf) bf.classList.add("is-selected");
      });
    }
    if (q.budget && LABELS.budget[q.budget]) {
      state.budget = q.budget;
      var bb = qs('[data-lf-choice="budget"][data-value="' + q.budget + '"]', root);
      if (bb) bb.classList.add("is-selected");
    }
    if (q.pref && LABELS.pref[q.pref]) {
      state.pref = q.pref;
      var b3 = qs('[data-lf-choice="pref"][data-value="' + q.pref + '"]', root);
      if (b3) b3.classList.add("is-selected");
    }

    // Jump logic
    if (
      q.go === "1" &&
      state.system &&
      state.nicotine &&
      state.flavors.length &&
      state.budget
    ) {
      if (!state.pref) state.pref = "none";
      showResults();
    } else if (state.system && state.nicotine && state.flavors.length && state.budget && state.pref) {
      showStep(4);
    } else if (state.system && state.nicotine && state.flavors.length && state.budget) {
      showStep(4);
    } else if (state.system && state.nicotine && state.flavors.length) {
      showStep(3);
    } else if (state.system && state.nicotine) {
      showStep(2);
    } else if (state.system) {
      showStep(1);
    } else {
      showStep(0);
    }
  }

  ready(function () {
    qsa("[data-lyd-liquid-finder]").forEach(init);
  });
})();
